export default __webpack_public_path__ + "static/media/element_40.e3c8c90e.webp";